// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui-snackbar-container{bottom:0;left:.5rem;overflow:hidden;pointer-events:none;position:fixed}.ui-snackbar-container .ui-snackbar{margin:.25rem .25rem .75rem;pointer-events:auto}.ui-snackbar-container--position-right{left:auto;right:.5rem}.ui-snackbar-container--position-center{display:flex;justify-content:center;left:.5rem;right:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
